export default "/images/52814e8e2014033dce4c056cd605792a.png";